<template>
    <el-empty class="content-empty">
        <div slot="description" v-if="type==1">暂无数据，请先进行<span class="color" @click="onConfig">配置</span></div>
        <div slot="description" v-if="type==2">
            最小区域层级所包含人数超过100，无法查看最小层级监控。如需查看请重新<span class="color" @click="onConfig">配置</span>层级。
        </div>
        <div slot="description" v-if="type==3">暂无数据，请先进行<span class="color" @click="onGroupConfig">配置</span></div>
    </el-empty>
</template>

<script>
    import {mapGetters, mapMutations} from "vuex";

    export default {
        name: "ContentEmpty",
        props: {
            type: {
                type: [String, Number],
                default: 0,
            }
        },
        data() {
            return {}
        },
        methods: {
            ...mapMutations([
                'setShowConfigLink',
                'setShowConfigGroup',
            ]),
            // 配置进度查看按钮
            onGroupConfig() {
                let that = this;
                that.setShowConfigGroup(true)
            },
            // 配置数据查看按钮
            onConfig() {
                let that = this;
                that.setShowConfigLink(true);
            },
        },
        computed: {
            ...mapGetters([
                'getShowConfigLink',
            ])
        },
    }
</script>

<style scoped>

</style>
